import AnnotatedImage from "../../../../src/components/annotated-image";
import plotterSetup from "../../../../src/posts/hashiconf-gen-art-overview/plotter-setup.jpg";
import * as React from 'react';
export default {
  AnnotatedImage,
  plotterSetup,
  React
};